import React from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from './Components/NavBar';
import Paper from './Components/Paper';
import useFetch from './Hooks/useFetch';
import ui from './index.module.css';

export default function index() {
  const location = useLocation();
  const { titleLesson, titleCourse, totalQuestions, lessonId, duration, courseId } = location.state;

  const { startTest, alreadyAnswered, loadingCheck } = useFetch({
    lessonId,
    courseId,
  });

  return (
    <div className={ui.mainContainer}>
      <NavBar title={titleCourse} />
      <Paper
        title={titleLesson}
        numberQuestions={totalQuestions}
        onClick={startTest}
        duration={duration}
        alreadyAnswered={alreadyAnswered}
        loadingCheck={loadingCheck}
      />
    </div>
  );
}
